var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-tooltip",
    [
      _vm.staffIsLoaded
        ? _c(
            "template",
            { slot: "contentTooltip" },
            [
              _c("compass-avatar", {
                attrs: {
                  initials: _vm.initials,
                  "is-blocked": _vm.isStaffBlocked(_vm.idStaff),
                  "is-deleted": _vm.isStaffDeleted(_vm.idStaff),
                  src: _vm.staff ? _vm.staff.avatar : "",
                  "color-type": _vm.randAvatarColor,
                  size: "extra-small"
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "semibold" }, [
                _vm._v(_vm._s(_vm.content))
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("CompassLink", {
        staticClass: "mention",
        class: _vm.color,
        attrs: {
          slot: "triggerTooltip",
          disabled: _vm.isStaffDeleted(_vm.idStaff),
          link: _vm.idStaff ? "/staff/" + _vm.idStaff : "#",
          target: _vm.idStaff ? "_blank" : "_self",
          label: _vm.text
        },
        slot: "triggerTooltip"
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }